export default __webpack_public_path__ + "assets/images/listen-icon6-db72dd84.svg";